<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title" *ngIf="approval && approval.equipment.name">
      {{ approval.equipment.name }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button (click)="matDialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group class="field-dialog__content">
    <mat-tab label="Geral">
      <tab-approvals-equipments (disableButtonApproval)="disableButtonApproval($event)"></tab-approvals-equipments>
    </mat-tab>

    <mat-tab label="Campos customizados">
      <tab-approvals-equipments-custom-fields></tab-approvals-equipments-custom-fields>
    </mat-tab>

    <mat-tab label="Fotos">
      <tab-approvals-equipments-attachments></tab-approvals-equipments-attachments>
    </mat-tab>
  </mat-tab-group>

  <div
    class="field-dialog__footer"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    *ngIf="statusApproval === 'pending'"
  >
    <div>
      <button [disabled]="disableButton" class="field-background mr-16" mat-raised-button (click)="openApproveDialog()">
        {{ 'APPROVALS_EQUIPMENTS.DIALOG.APPROVE_EQUIPMENT' | translate }}
      </button>

      <button color="warn" mat-raised-button (click)="openRejectDialog()">
        {{ 'APPROVALS_EQUIPMENTS.DIALOG.REJECT_EQUIPMENT' | translate }}
      </button>
    </div>
  </div>
</div>
